<div class="row">
  @for (c of content[type]; track c) {
    <div class="col-md-6 col-lg-3">
      <div class="hiw-block">
        <div class="hiw-img" style="background-image: url('{{c.img}}');"></div>
        <div class="p-3 pb-5">
          <h3 class="pb-4">{{c.title}}</h3>
          {{c.text}}
        </div>
      </div>
    </div>
  }
</div>
